type ContentSpacerProps = {
  width: number;
  height: number;
};

export const ContentSpacer = ({ width, height }: ContentSpacerProps) => (
  <rect
    width={width}
    height={height}
    fill="none"
    style={{ pointerEvents: 'none' }}
  />
);
